export default __webpack_public_path__ + "static/media/carousel-pic-one.d9b51033.png";